import { createFileRoute } from '@tanstack/react-router'

import { DirectoratesPage } from '@/features/user-management/DirectoratesPage'

export const Route = createFileRoute('/_authenticated/user-mgt/directorates')({
  component: DirectoratesPage,
})
